// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"d37f84b3","68":"2f64744e","586":"d0395c06","672":"fda661de","764":"e34a6da0","832":"b803a8f9"}[chunkId] + ".css";
};